import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/AutomaticallyCancelledBidsPopup.css';
import ModalDialog from '../ModalDialog';
import AutomaticallyCancelledBids from './AutomaticallyCancelledBids';
import {
    auctionType,
    bidsType,
} from '../../types';

AutomaticallyCancelledBidsPopup.propTypes = {
    onCancel: PropTypes.func.isRequired,
    auction: auctionType.isRequired,
    automaticallyCancelledBidsForMember: bidsType.isRequired,
};

function AutomaticallyCancelledBidsPopup(props) {
    const {
        onCancel,
        auction,
        automaticallyCancelledBidsForMember,
    } = props;
    const { t } = useTranslation();
    return (
        <ModalDialog onCancel={onCancel}>
            <div className="automatically-cancelled-bids-popup-dialog" role="dialog" aria-modal>
                <div className="automatically-cancelled-bids-popup-dialog--header">
                    <h4>{t('auctions.bids-list.automatically-cancelled-bids')}</h4>
                    <button type="button" className="close-button button-small button-primary-text automatically-cancelled-bids-popup-dialog--close" onClick={onCancel}>
                        <span aria-label={t('button.x')} title={t('button.x')} role="img">
                            <FontAwesomeIcon icon="times" />
                        </span>
                    </button>
                </div>
                <AutomaticallyCancelledBids
                    auction={auction}
                    automaticallyCancelledBidsForMember={automaticallyCancelledBidsForMember}
                />
            </div>
        </ModalDialog>
    );
}

export default AutomaticallyCancelledBidsPopup;
